import React, { useEffect, useState } from "react";
import { BrowserRouter as Router } from "react-router-dom";

import AppRoutes from "./routes";
import ComingSoon from "./components/ComingSoon";

function App() {

  const [showComingSoon, setShowComingSoon] = useState(true);

  useEffect(() => {

    const loader = document.getElementById("app-loader");

    if (loader) {
      loader.style.display = "none";
    }

  }, []);

  const handleEnterWebsite = () => {

    setShowComingSoon(false);

  };

  return (

    <Router>

      {showComingSoon ? (

        <ComingSoon
          onEnterWebsite={handleEnterWebsite}
        />

      ) : (

        <AppRoutes />

      )}

    </Router>

  );
}

export default App;